// extracted by mini-css-extract-plugin
export default {"wrap":"Banner_wrap__6mahd","head":"Banner_head__3Aq3A","title":"Banner_title__xB4Sm","text":"Banner_text__tmFcs","image":"Banner_image__iNess","image_mob":"Banner_image_mob__p7djI"};